import {Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import {Router} from '@angular/router';
import {RouterSegments} from 'src/app/models/router-segments';
import {AuthService} from 'src/app/services/auth/auth.service';
import {ServiceCardInfo} from '../../../models/service/service-card-info';
import {ServiceStatus} from '../../../models/service/service-status';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {ChangeState} from '../../../models/service/change-state';
import {ChangeTask} from 'src/app/models/service/change-task';

@Component({
    selector: 'app-service-card',
    templateUrl: './service-card.component.html',
    styleUrls: ['./service-card.component.scss'],
    standalone: false
})
export class ServiceCardComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  @Input() serviceCardInfo: ServiceCardInfo;

  readonly statusInfo: { [key: string]: any } = {
    [ServiceStatus.LIVE]: {icon: 'check', colorClass: 'green-1-bg'},
    [ServiceStatus.IN_PROGRESS]: {icon: 'loader', colorClass: 'accent-1-bg'},
    [ServiceStatus.DOWN]: {icon: 'alert-circle', colorClass: 'warn-solid-bg'},
  };

  ServiceStatus = ServiceStatus;
  ChangeState = ChangeState;
  isUpdateAvailable: boolean;
  isComingSoon: boolean;
  changeTask: ChangeTask;

  constructor(private router: Router, private authService: AuthService) {
    
  }

  ngOnInit(): void {
  }

  /**
   * After clicking a service card, the blueprints page will be opened
   */
  goToBlueprint(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.serviceCardInfo.service.id,
      RouterSegments.BLUEPRINTS, this.serviceCardInfo.blueprint.id]);
  }
}
